import Component from '../core/Component';
import Ajax from '../core/Ajax';

export default class LoadMore extends Component {
    url = null;
    reloadElement = null;

    constructor(element) {
        super(element);

       //this.url = element.dataset.url;
    }

    prepare() {
        this.element.addEventListener('click', ::this.loadMore);
        this.url = this.element.getAttribute('href');
        this.reloadElement = this.element.dataset.elem;
    }

    loadMore(event) {
        event.preventDefault();
        console.log('Clicked...', this.url);

        if (this.url === null) {
            return;
        }

        // this.url = this.element.data.reload;

        this.updateButton();

        const self = this;
        let ajax = new Ajax();
        ajax.get(this.url, null, function (payload) {
            const parser = new DOMParser();
            const virtualDocument = parser.parseFromString(payload, "text/html");

            const snippet = virtualDocument.getElementById(self.reloadElement);
            document.getElementById(self.reloadElement).innerHTML = snippet.innerHTML;

        }, () => {
            console.log('error');
        });
    }

    updateButton() {
        const btn = this.element;
        const url = new URL(this.url);
        const currentPage = url.searchParams.get('page');

        if (currentPage === null) {
            return '';
        }

        const updatedCurrentPage = parseInt(currentPage) + 1;
        url.searchParams.set('page', updatedCurrentPage);

        console.log(url);
        btn.setAttribute('href', url);



        // const parsedUrl = url.substring(0, (url.indexOf('=') + 1));

        // console.log(url.indexOf('='));

        // let currentPage = oldUrl.substring(0, oldUrl.indexOf('='));

        // btn.setAttribute('href', oldUrl + '=' )
    }
}
